import { useHistory } from 'react-router-dom';
import { Result } from '@ssar-app/uikit';
import { Button, HStack, Icon } from '@chakra-ui/react';
import { AiOutlineDoubleLeft } from 'react-icons/ai/index.js';
import { FaSignOutAlt } from 'react-icons/fa/index.js';

export const AccessDenied = () => {
  const history = useHistory();
  return (
    <Result
      status='403'
      title='Access Denied'
      subTitle='Sorry, you do not have access to this resource.'
      extra={
        <HStack>
          <Button
            colorScheme='gray'
            variant='outline'
            leftIcon={<Icon as={AiOutlineDoubleLeft} />}
            onClick={() => {
              history.goBack();
            }}
            boxShadow='lg'
          >
            Back
          </Button>
          <Button
            colorScheme='blue'
            leftIcon={<Icon as={FaSignOutAlt} />}
            onClick={() => {
              history.replace('/logout');
            }}
            boxShadow='lg'
          >
            Logout
          </Button>
        </HStack>
      }
    />
  );
};
